type IInitialConfigPayload = {
  type: Number;
};

export function initialConfigPayload(values: any): IInitialConfigPayload {
  const payload: IInitialConfigPayload = {
    ...values,
  };
  return payload;
}
